import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import { ApiPlugin } from '@/plugins/api-plugin'
import VueDatePicker from '@vuepic/vue-datepicker'
import MomentAdapter from '@date-io/moment'
import moment from 'moment/moment'
import 'moment-timezone'
moment.tz.setDefault('UTC')

import App from './App.vue'
import { lightTheme, darkTheme } from '@/plugins/vuetify/theme'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { mdi } from 'vuetify/iconsets/mdi'
import { customIcons } from '@/plugins/vuetify/custom-icons'

const vuetify = createVuetify({
    components: { ...components, VFileUpload, VDateInput },
    icons: {
        defaultSet: 'mdi',
        sets: {
            mdi,
            custom: customIcons,
        },
    },
    directives,
    locale: {
        locale: 'en',
    },
    date: {
        adapter: MomentAdapter,
        formats: {
            datetime: 'll HH:mm:ss',
            date: 'll',
        },
        locale: {
            en: 'en-GB',
        },
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: lightTheme,
            dark: darkTheme,
        },
    },
})

const pinia = createPinia()

const app = createApp(App)
    .use(vuetify)
    .use(router)
    .use(pinia)
    .use(ApiPlugin, { baseApiUrl: process.env.VUE_APP_API_URL })

app.component('VueDatePicker', VueDatePicker)

router.isReady().then(async () => {
    app.mount('#app')
})
